/** Posição do aparelho para o raio da loja (plan-notificacoes-whatsapp, 22/10/2026). */
export type DevicePosition = { latitude: number; longitude: number; accuracyMeters: number };

/**
 * Pede a posição ao navegador. Sem GPS, sem permissão ou sem resposta em 10 s
 * devolve `null` — quem decide se a posição é obrigatória é o backend
 * (`avaliacao.exigirLocalizacao`), que responde com a mensagem certa.
 */
export function getDevicePosition(timeoutMs = 10_000): Promise<DevicePosition | null> {
  if (typeof navigator === "undefined" || !navigator.geolocation) return Promise.resolve(null);
  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (pos) =>
        resolve({
          latitude: pos.coords.latitude,
          longitude: pos.coords.longitude,
          accuracyMeters: Math.round(pos.coords.accuracy),
        }),
      () => resolve(null),
      { enableHighAccuracy: true, timeout: timeoutMs, maximumAge: 60_000 },
    );
  });
}
